(function () {
  const nativeFetch = window.fetch.bind(window);
  const nativeOpen = typeof XMLHttpRequest !== 'undefined' ? XMLHttpRequest.prototype.open : null;
  const nativeSend = typeof XMLHttpRequest !== 'undefined' ? XMLHttpRequest.prototype.send : null;

  function packData() {
    const data = window.csPackCartVariants || {};
    if (data.ids && typeof data.ids === 'object') return data;
    return { ids: data, bundles: {} };
  }

  function map() {
    return packData().ids || {};
  }

  function bundleNames() {
    const bundles = packData().bundles;
    return bundles && typeof bundles === 'object' ? bundles : {};
  }

  function bundleByProduct() {
    const products = packData().products;
    return products && typeof products === 'object' ? products : {};
  }

  function singleId(id) {
    if (id == null) return null;
    const next = map()[String(id)];
    return next == null ? null : String(next);
  }

  function singleVariantIds() {
    return new Set(Object.values(map()).map((id) => String(id)));
  }

  // Pack variant ids carry the pack label. An existing _bundle (warehouse clearance)
  // is kept when the line is already a CLIPSTIC Plus colour.
  function bundleName(id, properties) {
    const fromPack = bundleNames()[String(id)];
    if (typeof fromPack === 'string' && fromPack) return fromPack;
    const existing = properties && properties._bundle;
    return typeof existing === 'string' && existing ? existing : '';
  }

  // Pack variant ids and the six CLIPSTIC Plus colour ids.
  function colourId(id) {
    if (id == null || id === '') return null;
    const mapped = singleId(id);
    if (mapped) return mapped;
    const key = String(id);
    return singleVariantIds().has(key) ? key : null;
  }

  // Kaching free gift (fix 2026-10-22): a CLIPSTIC Plus colour variant that carries a
  // __kaching_bundles property is a Kaching deal line (the Wall Mount free clip). Leave it
  // alone, or Kaching cannot price it at 0. Pack variants (keys of the map) are still remapped.
  function isKachingGift(id, hasKachingProperty) {
    return Boolean(hasKachingProperty) && !singleId(id);
  }

  function kachingMeta(properties) {
    const raw = properties && properties.__kaching_bundles;
    if (typeof raw !== 'string' || !raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  // Kaching's main colour is already a CLIPSTIC Plus variant, so the free-gift
  // skip would leave it untagged. Add _bundle and keep __kaching_bundles.
  function mainPackLabel(properties) {
    const meta = kachingMeta(properties);
    if (!meta || meta.main !== true || meta.pp == null) return '';
    const label = bundleByProduct()[String(meta.pp)];
    return typeof label === 'string' ? label : '';
  }

  function kachingRaw(properties) {
    const raw = properties && properties.__kaching_bundles;
    return typeof raw === 'string' && raw ? raw : '';
  }

  // Keep __kaching_bundles. Kaching's discount reads that tag; without it the
  // cart charges the full CLIPSTIC Plus price. _bundle stays so the pack name
  // is on the order and the line does not merge with a normal Plus add.
  function propertiesForPack(bundle, kaching) {
    const properties = {};
    if (bundle) properties._bundle = bundle;
    if (kaching) properties.__kaching_bundles = kaching;
    return properties;
  }

  function applyBundleLine(item) {
    if (isKachingGift(item.id, item.properties && item.properties.__kaching_bundles)) {
      const label = mainPackLabel(item.properties);
      if (!label || item.properties._bundle === label) return false;
      item.properties = Object.assign({}, item.properties, { _bundle: label });
      return true;
    }
    const next = colourId(item.id);
    if (!next) return false;
    const bundle = bundleName(item.id, item.properties);
    const kaching = kachingRaw(item.properties);
    item.id = Number(next);
    delete item.parent_id;
    delete item.selling_plan;
    const properties = propertiesForPack(bundle, kaching);
    if (Object.keys(properties).length) item.properties = properties;
    else delete item.properties;
    return true;
  }

  function remapJson(data) {
    const items = Array.isArray(data) ? data : Array.isArray(data.items) ? data.items : data.id != null ? [data] : null;
    if (!items) return false;

    let changed = false;
    for (const item of items) {
      if (applyBundleLine(item)) changed = true;
    }
    return changed;
  }

  function bundleField(prefix) {
    return prefix ? `${prefix}properties][_bundle]` : 'properties[_bundle]';
  }

  function stripFormFields(body, prefix) {
    const tail = prefix ? ']' : '';
    for (const key of [...body.keys()]) {
      if (
        key === `${prefix}selling_plan${tail}` ||
        key === `${prefix}parent_id${tail}` ||
        key.startsWith(`${prefix}properties`)
      ) {
        body.delete(key);
      }
    }
  }

  function remapBody(body) {
    if (!body) return body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      const directId = body.get('id');
      const direct = colourId(directId);
      if (direct && isKachingGift(directId, body.has('properties[__kaching_bundles]'))) {
        const label = mainPackLabel({ __kaching_bundles: body.get('properties[__kaching_bundles]') });
        if (label) body.set(bundleField(''), label);
      } else if (direct && !isKachingGift(directId, body.has('properties[__kaching_bundles]'))) {
        const bundle = bundleName(directId, { _bundle: body.get(bundleField('')) });
        const kaching = body.get('properties[__kaching_bundles]');
        body.set('id', direct);
        stripFormFields(body, '');
        if (bundle) body.set(bundleField(''), bundle);
        if (typeof kaching === 'string' && kaching) body.set('properties[__kaching_bundles]', kaching);
      }

      for (const [key, value] of [...body.entries()]) {
        const match = key.match(/^(?:items|shopify-additional-items)\[(\d+)\]\[id\]$/);
        const next = match && colourId(value);
        if (!next) continue;
        const prefix = key.replace(/id\]$/, '');
        if (isKachingGift(value, body.has(`${prefix}properties][__kaching_bundles]`))) {
          const label = mainPackLabel({ __kaching_bundles: body.get(`${prefix}properties][__kaching_bundles]`) });
          if (label) body.set(bundleField(prefix), label);
          continue;
        }
        const bundle = bundleName(value, { _bundle: body.get(bundleField(prefix)) });
        const kachingKey = `${prefix}properties][__kaching_bundles]`;
        const kaching = body.get(kachingKey);
        body.set(key, next);
        stripFormFields(body, prefix);
        if (bundle) body.set(bundleField(prefix), bundle);
        if (typeof kaching === 'string' && kaching) body.set(kachingKey, kaching);
      }
      return body;
    }

    if (typeof body !== 'string') return body;

    const trimmed = body.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        const data = JSON.parse(body);
        return remapJson(data) ? JSON.stringify(data) : body;
      } catch {
        return body;
      }
    }

    if (!body.includes('id=')) return body;
    const params = new URLSearchParams(body);
    const direct = colourId(params.get('id'));
    if (!direct) return body;
    if (isKachingGift(params.get('id'), params.has('properties[__kaching_bundles]'))) {
      const label = mainPackLabel({ __kaching_bundles: params.get('properties[__kaching_bundles]') });
      if (!label) return body;
      params.set('properties[_bundle]', label);
      return params.toString();
    }
    const bundle = bundleName(params.get('id'), { _bundle: params.get('properties[_bundle]') });
    const kaching = params.get('properties[__kaching_bundles]');
    params.set('id', direct);
    for (const key of [...params.keys()]) {
      if (key === 'selling_plan' || key === 'parent_id' || key.startsWith('properties[')) params.delete(key);
    }
    if (bundle) params.set('properties[_bundle]', bundle);
    if (kaching) params.set('properties[__kaching_bundles]', kaching);
    return params.toString();
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function cartUrl(file) {
    const routes = window.Theme && window.Theme.routes;
    if (routes && file === 'cart.js') return `${routes.cart_url}.js`;
    if (routes && file === 'cart/add.js') return routes.cart_add_url;
    if (routes && file === 'cart/update.js') return `${routes.cart_update_url}.js`;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/?$/, '/')}${file.replace(/^\//, '')}`;
  }

  function lineVariantId(item) {
    return String(item.variant_id || item.id || '');
  }

  function bundleOf(item) {
    const value = item.properties && item.properties._bundle;
    return typeof value === 'string' ? value : '';
  }

  function isKeeper(item, resolved, bundle) {
    if (lineVariantId(item) !== resolved || item.selling_plan_allocation) return false;
    const properties = item.properties || {};
    const keys = Object.keys(properties).filter((key) => properties[key] != null && properties[key] !== '');
    if (bundle) return keys.length === 1 && keys[0] === '_bundle' && properties._bundle === bundle;
    return keys.length === 0;
  }

  async function readCart() {
    const response = await nativeFetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) return null;
    return response.json();
  }

  // Fold duplicate lines of one CLIPSTIC Plus colour that share a _bundle value.
  // A pack line stays separate from a normal Plus line of the same colour.
  async function consolidate() {
    if (!Object.keys(map()).length) return false;
    const cart = await readCart();
    if (!cart || !Array.isArray(cart.items)) return false;

    const groups = new Map();
    for (const item of cart.items) {
      if (isKachingGift(lineVariantId(item), item.properties && item.properties.__kaching_bundles)) continue;
      if (item.item_components && item.item_components.length) continue;
      const resolved = colourId(lineVariantId(item));
      if (!resolved || !item.key) continue;
      const bundle = bundleOf(item);
      const groupKey = `${resolved}\n${bundle}`;
      const lines = groups.get(groupKey) || [];
      lines.push(item);
      groups.set(groupKey, lines);
    }

    const updates = {};
    const toAdd = [];

    for (const [groupKey, lines] of groups) {
      const splitAt = groupKey.indexOf('\n');
      const resolved = groupKey.slice(0, splitAt);
      const bundle = groupKey.slice(splitAt + 1);
      const wrongVariant = lines.some((line) => lineVariantId(line) !== resolved);
      if (lines.length < 2 && !wrongVariant) continue;

      const total = lines.reduce((sum, line) => sum + Number(line.quantity || 0), 0);
      const keeper = lines.find((line) => isKeeper(line, resolved, bundle));
      if (keeper) {
        if (Number(keeper.quantity) !== total) updates[keeper.key] = total;
        for (const line of lines) {
          if (line.key !== keeper.key) updates[line.key] = 0;
        }
      } else {
        const add = { id: Number(resolved), quantity: total };
        if (bundle) add.properties = { _bundle: bundle };
        toAdd.push(add);
        for (const line of lines) updates[line.key] = 0;
      }
    }

    if (!toAdd.length && !Object.keys(updates).length) return false;

    if (toAdd.length) {
      const added = await nativeFetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: toAdd }),
      });
      if (!added.ok) return false;
    }

    if (Object.keys(updates).length) {
      const updated = await nativeFetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!updated.ok) return false;
    }

    return true;
  }

  async function withoutStaleSections(response) {
    const copy = response.clone();
    let payload;
    try {
      payload = await copy.json();
    } catch {
      return response;
    }
    if (!payload || typeof payload !== 'object' || Array.isArray(payload) || !payload.sections) return response;
    delete payload.sections;
    const headers = new Headers(response.headers);
    headers.delete('content-length');
    headers.delete('content-encoding');
    return new Response(JSON.stringify(payload), {
      status: response.status,
      statusText: response.statusText,
      headers,
    });
  }

  let chain = Promise.resolve();

  function enqueue(task) {
    const result = chain.then(task, task);
    chain = result.then(
      () => undefined,
      () => undefined
    );
    return result;
  }

  async function addAndMerge(input, init) {
    let nextInit = init;
    try {
      if (init && Object.prototype.hasOwnProperty.call(init, 'body')) {
        nextInit = Object.assign({}, init, { body: remapBody(init.body) });
      }
    } catch (error) {
      console.error(error);
    }

    const response = await nativeFetch(input, nextInit);
    if (!response.ok) return response;

    try {
      const changed = await consolidate();
      return changed ? await withoutStaleSections(response) : response;
    } catch (error) {
      console.error(error);
      return response;
    }
  }

  window.fetch = function (input, init) {
    if (!requestUrl(input).includes('/cart/add')) return nativeFetch(input, init);
    return enqueue(() => addAndMerge(input, init));
  };

  if (nativeOpen && nativeSend) {
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__csUrl = typeof url === 'string' ? url : String(url || '');
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (String(this.__csUrl || '').includes('/cart/add')) body = remapBody(body);
      } catch (error) {
        console.error(error);
      }
      return nativeSend.call(this, body);
    };
  }
})();
